import React from 'react'
import styled from 'styled-components'

import { useMedia } from '@/utils/use-media'
import ShapesImage from '@/assets/images/shapes/sdk.svg'
import { desktop, mobile } from '@/utils/media-query'
import { useIsMounted } from '@/utils/use-is-mounted'

import { EndBreaker } from './end-breaker'
import { Footer } from './footer'
import { GifCarousel } from './gif-carousel'
import { GiphyTextSection } from './giphy-text-section'
import { Header } from './header'
import { IntroSection } from './intro-section'
import { KitCarouselSection } from './kit-carousel-section'
import { Shapes } from './shapes'
import { WhyGiphySection } from './why-giphy-section'

const Centered = styled.div`
  section {
    margin-bottom: ${({ theme }) => theme.sectionMargin}px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 32px;
  }

  @media ${desktop.query} {
    width: 100%;
    margin: 0 auto;
  }

  @media ${mobile.query} {
    width: 100%;

    section {
      margin-bottom: ${({ theme }) => theme.sectionMobileMargin}px;
      padding: 0 ${({ theme }) => theme.containerMobilePadding}px;

      &:first-child {
        margin-bottom: 0;
        padding: 0;
      }
    }
  }

  &:first-child {
    section:first-child {
      margin-bottom: 0;
    }
  }

  &:last-child {
    section:last-child {
      margin-bottom: 0;
    }
  }
`

const SDKContainer = styled.div`
  position: relative;
  margin-bottom: ${({ theme }) => theme.sectionMargin}px;
  max-width: ${({ theme }) => theme.containerWidth}px;
  width: 100%;

  @media ${mobile.query} {
    margin-bottom: ${({ theme }) => theme.sectionMobileMargin}px;
  }
`

const GifCarouselContainer = styled.div`
  position: relative;
  padding-top: 200px;
  width: 100%;

  @media ${mobile.query} {
    padding-top: 0;
  }
`

const GifCarouselShapes = styled(Shapes)`
  top: 0;
  height: 385%;

  &:before {
    background-size: cover;
  }
`

const LandingPage = () => {
  const isMobileScreen = useMedia(mobile.query, false)
  const isMounted = useIsMounted()

  return (
    <>
      <Centered>
        <Header />
        <IntroSection />
        <GiphyTextSection />
      </Centered>
      <KitCarouselSection />
      <GifCarouselContainer>
        {isMounted && !isMobileScreen && <GifCarouselShapes source={ShapesImage} />}
        <GifCarousel />
      </GifCarouselContainer>
      <SDKContainer>
        <Centered>
          <WhyGiphySection />
        </Centered>
      </SDKContainer>
      <EndBreaker />
      <Centered>
        <Footer />
      </Centered>
    </>
  )
}

export default LandingPage
